<template>
  <div class="container" :style="{ height: contentRefHeight }">
    <!-- 日期选择 -->
    <div ref="contentRef" class="date-content">
      <van-row type="flex" justify="space-between">
        <van-col class="date-content-date">
          <van-tabs v-model="selectDateIndex" type="card" @click="onSelectDate" color="#0ed66b"
            title-inactive-color="#000" title-active-color="#fff">
            <van-tab v-for="(item, index) in dateList" :key="index">
              <template slot="title">
                <p>{{ item.formattedDate }}</p>
                <p>{{ item.week }}</p>
              </template>
            </van-tab>
          </van-tabs>
        </van-col>
        <van-col class="date-content-btn flex flex-justify-center flex-items-center">
          <div @click="onCalendar">
            <p>全部</p>
            <p>日期</p>
          </div>
        </van-col>
      </van-row>
    </div>
    <!-- 日历组件 -->
    <Calendar ref="calendar" :title="calendarTitle" :default-date="caldendarDefaultDate" :max-date="maxDate"
      :min-date="minDate" @confirm="onConfirm"></Calendar>
  </div>
</template>

<script>
import dateCalendarStore from "@/stores/dateCalendarStore";
import Calendar from "./calendar.vue";

const weekDays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

export default {
  name: "SelectDate",
  components: {
    Calendar,
  },
  model: {
    prop: "selectDate",
    event: "update:selectDate",
  },
  props: {
    // 父组件用于请求的时间
    selectDate: {
      type: [Date, String, Object],
    },
    /**
     * 返回给父组件的日期格式化
     * 父组件使用👉:format="(date)=>$moment(date).fotmat('你想要返回的格式')"
     */
    format: {
      type: Function,
      default: function (date) {
        return this.$moment(date).format("YYYY-MM-DD");
      },
    },
  },
  data() {
    return {
      dateList: dateCalendarStore.state.dateList || [], // 日期列表
      // 日历默认日期
      caldendarDefaultDate:
        dateCalendarStore.state.caldendarDefaultDate || new Date(),
      selectDateIndex: dateCalendarStore.state.selectDateIndex || 0, // 选择日期的索引
      minDate: new Date(), // 日历最小日期:动态控制
      maxDate: new Date(
        this.$moment()
          .add(1, "M")
          .endOf("M")
      ), // 日历最大日期
      calendarTitle: "日期选择", // 日历标题
      contentRefHeight: 0,
    };
  },
  watch: {
    // 监听相关变量，改变仓库的值
    dateList() {
      dateCalendarStore.commit("setDateList", this.dateList);
    },
    selectDate(value) {
      dateCalendarStore.commit("setSelectDate", this.selectDate);
    },
    selectDateIndex() {
      dateCalendarStore.commit("setSelectDateIndex", this.selectDateIndex);
    },
    caldendarDefaultDate() {
      dateCalendarStore.commit("setDefaultDate", this.caldendarDefaultDate);
    },
  },
  methods: {
    /**
     * 日期选择函数
     *
     * 触发函数接收tabs组件传入的索引index，通过索引拿到选中的日期，改变日历的默认日期及tbas组件的索引，
     * 并emit格式化好的日期发请求
     * @param {Number} index tabs组件默认参数👉索引
     */
    onSelectDate(index) {
      const { date } = this.dateList[index];
      this.caldendarDefaultDate = new Date(date);
      this.selectDateIndex = index;
      this.$emit("update:selectDate", this.format(date));
    },
    /**
     * 日历确认函数
     *
     * 选择日历中的日期，关闭日历改变日历默认日期，emit日期发请求，
     * 判断选择的日期是否在dateList中，找不到重新生成新的dateList并初始化日期索引为0，找到则只改变索引
     * @param {Event} event 事件对象
     */
    onConfirm(e) {
      let that = this;
      // 改变日历默认日期
      that.caldendarDefaultDate = e;
      this.$emit("update:selectDate", this.format(e));
      const fullDate = that.$moment(e).format("YYYY-MM-DD");
      // 在原dateList没有找到，则不用重新渲染新的dateList，而是切换tabs
      const findResult = that.dateList.some((item, index) => {
        if (item.fullDate == fullDate) {
          this.selectDateIndex = index;
          return true;
        }
      });
      if (findResult) return;
      this.selectDateIndex = 0;
      // 如果没有找到则重新渲新的dateList
      this.$nextTick(() => {
        that.generateDateList(e);
      });
    },
    /**
     * 打开日历函数
     *
     * 超级用户可选近一年的时间，非超级用户则根据 AllowedToQueryClassDaysAgo 返回的值动态控制
     */
    onCalendar() {
      this.caldendarDefaultDate = new Date(this.caldendarDefaultDate);
      //TASK#3068 为确保信息安全，手持机上设置参数只能查前几天的数据。时间客户自己定 参数名:AllowedToQueryClassDaysAgo
      //非超级用户 参数不为空 才判断
      // let dayAgo = (
      //   this.$utils.getSysParams("AllowedToQueryClassDaysAgo") || ""
      // ).trim();
      // if (
      //   !JSON.parse(window.localStorage.getItem("adminInfo")).IsSuperUser &&
      //   dayAgo
      // ) {
      //   this.minDate = new Date(
      //     this.$moment()
      //       .add(parseInt(dayAgo), "d")
      //       .endOf("d")
      //   );
      //   this.calendarTitle = "日期选择";
      // } else {

      // }

      // 超级用户可查看近一年数据
      this.minDate = new Date(this.$moment().add(-1, "y"));
      this.calendarTitle = "日期选择(仅可查询1年内)";
      this.$refs.calendar.show = true;
    },
    /**
     * 生成日期列表
     *
     * 用于生成dateList日期数组，组件创建时触发一次，通过外部传入的selectDate生成selectDate起的15天内的日期
     * 日历选择的日期不在15天内则通过改变后的selectDate重新生成选择后的15天内的日期
     * @param {Date} date 日期
     */
    generateDateList(date) {
      const that = this;
      const selectDate = this.$moment(date);
      const fullDate = selectDate.format("YYYY-MM-DD");
      if (that.dateList.some((item) => item.fullDate == fullDate)) return;
      const list = [];
      for (let i = 0; i < 15; i++) {
        const date = that.$moment(selectDate).add(i, "d");
        const formattedDate = that.formatDate(date, weekDays);
        list.push(formattedDate);
      }
      that.dateList = list;
    },
    /**
     * 日期格式化函数
     * @param {string} date 每天的日期
     * @param {[string]} weekDays 一周的字符串数组
     * @returns {object} 返回格式化数据
     * - date 日期
     * - formattedDate 格式化日期
     * - fullDate 完整日期
     * - week 周一至周日
     */
    formatDate(date, weekDays) {
      let that = this;
      let week = "";
      const today = that.$moment();
      const tomorrow = that.$moment().add(1, "d");
      const afterTomorrow = that.$moment().add(2, "d");
      switch (true) {
        case date.isSame(today, "d"):
          week = "今天";
          break;
        case date.isSame(tomorrow, "d"):
          week = "明天";
          break;
        case date.isSame(afterTomorrow, "d"):
          week = "后天";
          break;
        default:
          week = weekDays[date.day()];
          break;
      }
      const formattedDate = date.format("MM-DD");
      const fullDate = date.format("YYYY-MM-DD");
      return {
        date,
        formattedDate,
        fullDate,
        week,
      };
    },
  },
  created() {
    this.generateDateList(this.selectDate);
  },
  mounted() {
    this.contentRefHeight = this.$refs.contentRef.offsetHeight + "px";
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  margin-bottom: 10px;
}

.date-content {
  width: 100%;
  height: auto;
  position: fixed;
  z-index: 2;
  background-color: #fff;

  .date-content-date {
    width: 88%;
    display: -webkit-box;
    //   display: flex;
    //   justify-content: space-between;
    font-size: 15px;
    text-align: center;
    padding: 5px 0 5px 10px;
    overflow: hidden;

    & /deep/ .van-tabs {
      width: 100%;

      .van-tabs__wrap {
        height: 100%;

        .van-tabs__nav--card {
          height: 100% !important;
          margin: 0;
          padding: 0;
          border: none;

          .van-tab {
            border: none;
            padding: 0 9px;
            margin: 0 2px;
          }

          .van-tab--active {
            border-radius: 10px;
          }
        }
      }
    }

    .date-content-itemBox {
      width: 100%;
      display: flex;
      justify-content: space-between;
      overflow: auto;

      .date-content-item {
        width: 18%;
        flex-shrink: 0;
        border-radius: 10px;
        padding: 5px 0;
      }

      .date-content-item-active {
        font-weight: bold;
        color: #fff;
        background-color: #0ed66b;
      }
    }
  }

  .date-content-btn {
    width: 12%;
    font-size: 15px;
    padding: 5px 0;
    box-shadow: -1px -1px 2px 0px #999;
    z-index: 1;
  }
}
</style>
